import { useCallback, useState } from 'react';
import qs from 'qs';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isPlainObject from 'lodash/isPlainObject';

import { API_ENDPOINTS } from 'config/env';

/**
 * @type {Record<import("utils/types").EcommPlatformSource, *>}
 */
const OAUTH_BEGIN_API_ROUTE = {
  SHOPIFY: API_ENDPOINTS.storeConnect.shopify,
  WOOCOMMERCE: API_ENDPOINTS.storeConnect.woo,
  BIGCOMMERCE: API_ENDPOINTS.storeConnect.bigcommerce
};

export default function useStoreConnection() {
  const [connectingStore, setConnectingStore] = useState(null);

  const onInitiateConnect = useCallback(
    /**
     * @param {import("utils/types").EcommPlatformSource} ecommPlatform
     * @param {object} payload
     */
    (ecommPlatform = '', payload = null) => {
      const route = OAUTH_BEGIN_API_ROUTE[ecommPlatform];

      if (!_isPlainObject(payload) || _isEmpty(payload) || !route) return;

      const store = _get(payload, 'shop', '');
      setConnectingStore(store);
      const queryString = qs.stringify(payload);
      window.location = `${process.env.REACT_APP_BASE_URL}${route}?${queryString}`;
    },
    []
  );

  return {
    onInitiateConnect,
    connectingStore,
    isProcessing: !!connectingStore
  };
}
